"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianMediaCenter = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var Resources_1 = require("../../Resources");
var SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
var SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var Turmoil_1 = require("../../turmoil/Turmoil");
var MartianMediaCenter = (function (_super) {
    __extends(MartianMediaCenter, _super);
    function MartianMediaCenter() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MARTIAN_MEDIA_CENTER,
            tags: [Tags_1.Tags.BUILDING],
            cost: 7,
            productionBox: Units_1.Units.of({ megacredits: 2 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.MARS); }),
            metadata: {
                cardNumber: 'T07',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Pay 3 M€ to add a delegate to any party.', function (eb) {
                        eb.megacredits(3).startAction.delegates(1);
                    }).br;
                    b.production(function (pb) {
                        pb.megacredits(2);
                    });
                }),
                description: 'Requires that Mars First is ruling or that you have 2 delegates there. Increase your M€ production 2 steps.',
            },
        }) || this;
    }
    MartianMediaCenter.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        return undefined;
    };
    MartianMediaCenter.prototype.canAct = function (player) {
        return player.canAfford(3) && Turmoil_1.Turmoil.getTurmoil(player.game).hasAvailableDelegates(player.id);
    };
    MartianMediaCenter.prototype.action = function (player) {
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 3, { title: 'Select how to pay for Martian Media Center action' }));
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send a delegate', { source: 'reserve' }));
        return undefined;
    };
    return MartianMediaCenter;
}(Card_1.Card));
exports.MartianMediaCenter = MartianMediaCenter;
